export default __webpack_public_path__ + "static/media/Saqlain_CV.1b24803a.pdf";